export { default } from './Unstable_TrapFocus';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Unstable_TrapFocus/index.js
// module id = 604
// module chunks = 121